import NoDataIcon from '@/src/assets/images/svg/no_reports.svg';

const NoReports = (): JSX.Element => {
  return (
    <div className="flex flex-col items-center align-top">
      <div className="h-[72px] w-[72px] shadow-md rounded-[50%] flex justify-center items-center">
        <img className="" src={NoDataIcon} alt="" />
      </div>
      <h2 className="text-inter-black text-xl font-medium py-2">
        No Reports added yet
      </h2>

      <span className="text-grey-black-color text-sm font-medium text-center">
        There is no reports added
        <br /> by the user yet
      </span>
    </div>
  );
};

export default NoReports;
